import type { AdminRouterItem } from "../router";
import {
  BookOpenRegular,
  PeopleLockRegular,
  ApprovalsAppFilled,
  AppsListRegular,
} from "@fluentui/react-icons";
import RolePage from "./components/role.tsx";
import DetailView from "./components/detailview.tsx";
import Dashboard from "./index.tsx";
import Disziplinenverwaltung from "./components/disziplinenverwaltung.tsx";
import Freigaben from "./components/freigaben.tsx";

const dashboardRoutes: AdminRouterItem[] = [
  {
    path: "",
    element: <Dashboard />,
    meta: {
      label: "Dashboard",
      title: "Dashboard",
      key: "/",
      icon: <AppsListRegular />,
      allowedRoles: [
        "Admin",
        "Entwickler*in",
        "Freigeber*in",
        "Kollegium",
        "Hochschulleitung",
        "Controlling",
        "Studiengangsleiter*in",
      ],
    },
  },
  {
    path: "detail",
    element: <DetailView />,
    meta: {
      label: "Detail",
      title: "Detail",
      key: "/detail",
      hideInMenu: true,
      allowedRoles: [
        "Admin",
        "Entwickler*in",
        "Freigeber*in",
        "Kollegium",
        "Hochschulleitung",
        "Controlling",
        "Studiengangsleiter*in",
      ],
    },
  },
  {
    path: "role",
    element: <RolePage />,
    meta: {
      label: "Rollenverwaltung",
      title: "Rollenverwaltung",
      key: "/role",
      icon: <PeopleLockRegular />,
      allowedRoles: ["Admin"],
    },
  },
  {
    path: "disziplinenverwaltung",
    element: <Disziplinenverwaltung />,
    meta: {
      label: "Disziplinenverwaltung",
      title: "Disziplinenverwaltung",
      key: "/disziplinenverwaltung",
      icon: <BookOpenRegular />,
      allowedRoles: ["Admin"],
    },
  },
  {
    path: "freigaben",
    element: <Freigaben />,
    meta: {
      label: "Freigaben",
      title: "Freigaben",
      key: "/freigaben",
      icon: <ApprovalsAppFilled />,
      allowedRoles: ["Admin"],
    },
  },
];

export default dashboardRoutes;
